import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLightningIconSecondary from './svgs/LightningIconSecondary.js';
import SvgLightningIcon from './svgs/LightningIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lightningIcon = (props => useIcon(SvgLightningIcon, SvgLightningIconSecondary, props));

export { lightningIcon as default };
